import { isString } from 'lodash';
import pathToRegexp from 'path-to-regexp';

import logger from 'utils/logger.util';

const L = logger('parsePath');

const parsePath = (options) => {
  try {
    const { pattern, path } = options;

    if (!pattern || !isString(pattern) || !isString(path)) {
      L.error('()', 'Invalid options:', options);
      return null;
    }

    // SEE: https://www.npmjs.com/package/path-to-regexp/v/1.7.0
    const result = pathToRegexp(pattern).exec(path);

    // if not null, the result will be iterable, but not array, so convert it
    return result ? [...result] : result;
  } catch (e) {
    L.warn('()', e, 'tried to parse with:', options);
    return null;
  }
};

// noinspection JSUnusedGlobalSymbols
export default parsePath;
